import { supabase } from "./supabase";

// Cache for whitelist to avoid repeated database calls
let whitelistCache = null;
let cacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

// Get active whitelist from database with caching
export const getActiveWhitelist = async () => {
  const now = Date.now();

  // Return cached data if it's still valid
  if (
    whitelistCache &&
    cacheTimestamp &&
    now - cacheTimestamp < CACHE_DURATION
  ) {
    return whitelistCache;
  }

  try {
    const { data, error } = await supabase.rpc("get_active_whitelist");

    if (error) {
      console.error("Error fetching whitelist:", error);
      // Return empty array if there's an error, so the function doesn't break
      return [];
    }

    // Update cache
    whitelistCache = data || [];
    cacheTimestamp = now;

    return whitelistCache;
  } catch (err) {
    console.error("Error in getActiveWhitelist:", err);
    return [];
  }
};

// Clear the whitelist cache (useful when whitelist is updated)
export const clearWhitelistCache = () => {
  whitelistCache = null;
  cacheTimestamp = null;
};

// Dynamic version of extractAffiliateName that uses database whitelist
export const extractAffiliateNameDynamic = async (adName) => {
  if (!adName) return "Hercules Team";

  const adNameLower = adName.toLowerCase();
  const whitelist = await getActiveWhitelist();

  // Check each whitelist entry
  for (const entry of whitelist) {
    const { affiliate_name, patterns } = entry;

    // If there are patterns, check if any pattern matches
    if (patterns && patterns.length > 0) {
      for (const pattern of patterns) {
        if (adNameLower.includes(pattern.toLowerCase())) {
          return affiliate_name;
        }
      }
    }

    // If no patterns, check for exact name match (case-insensitive)
    if (adNameLower.includes(affiliate_name.toLowerCase())) {
      return affiliate_name;
    }
  }

  return "Hercules Team";
};

// Synchronous version that falls back to cached data
export const extractAffiliateNameSync = (adName) => {
  if (!adName) return "Hercules Team";

  const adNameLower = adName.toLowerCase();

  // Use cached whitelist if available
  if (whitelistCache) {
    for (const entry of whitelistCache) {
      const { affiliate_name, patterns } = entry;

      // If there are patterns, check if any pattern matches
      if (patterns && patterns.length > 0) {
        for (const pattern of patterns) {
          if (adNameLower.includes(pattern.toLowerCase())) {
            return affiliate_name;
          }
        }
      }

      // If no patterns, check for exact name match (case-insensitive)
      if (adNameLower.includes(affiliate_name.toLowerCase())) {
        return affiliate_name;
      }
    }
  }

  return "Hercules Team";
};

// Initialize whitelist cache on module load
getActiveWhitelist().catch(console.error);

// Export for backward compatibility and immediate use
export { extractAffiliateNameDynamic as extractAffiliateName };
